import type { ApiFieldIssue } from '~/services/api/ApiFieldIssue'
import { PhoneNumber } from '~/utils/PhoneNumber'
import { phoneIssueVerdict } from './phoneIssueVerdict'
import { resolvePhoneMessageOr } from './resolvePhoneMessageOr'
import { fieldErrorPresenterByCode } from './fieldErrorPresenterByCode'
import type { TranslateFn } from './TranslateFn'

/** The localized message for one field issue; an issue that points at a phone field gets the phone copy. */
export function resolveFieldIssueMessage(
  issue: Pick<ApiFieldIssue, 'code' | 'params'> & { readonly source?: ApiFieldIssue['source'] },
  t: TranslateFn
): string {
  const issueVerdict = phoneIssueVerdict(
    issue.source === undefined
      ? undefined
      : PhoneNumber.verdictOfIssue({ code: issue.code, source: issue.source })
  )
  return resolvePhoneMessageOr(t, issueVerdict, () => {
    const { key, values } = fieldErrorPresenterByCode[issue.code](issue.params, t)

    return t(key, { ...values })
  })
}
